module.exports = [
	{
		"profit": 20490,
		"merchandisable": true,
		"raw": false,
		"date": 1958,
		"cost": 640,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Accordion",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 2540,
		"totalProfit": 20490,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 22150,
		"totalCost": 1660,
		"index": 0
	},
	{
		"profit": 24510,
		"merchandisable": true,
		"raw": false,
		"date": 1960,
		"cost": 1770,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Action Heros",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 2540,
		"totalProfit": 24510,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 27300,
		"totalCost": 2790,
		"index": 1
	},
	{
		"profit": -840,
		"merchandisable": false,
		"raw": false,
		"date": 1923,
		"cost": 420,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Aluminum",
		"soldAt": "NOPE",
		"manufacturedAt": "Forge",
		"ingredientsWorth": 0,
		"totalProfit": -840,
		"composition": [
			"Bauxite"
		],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 840,
		"index": 2
	},
	{
		"profit": 21600,
		"merchandisable": true,
		"raw": false,
		"date": 1942,
		"cost": 2560,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Aluminum Ladder",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 0,
		"totalProfit": 21600,
		"composition": [
			"Aluminum"
		],
		"isWorthIt": true,
		"price": 25000,
		"totalCost": 3400,
		"index": 3
	},
	{
		"profit": 39950,
		"merchandisable": true,
		"raw": false,
		"date": 1947,
		"cost": 2570,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Amplifier",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 27200,
		"totalProfit": 39950,
		"composition": [
			"Wooden Board",
			"Steel",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 48000,
		"totalCost": 8050,
		"index": 4
	},
	{
		"profit": 13590,
		"merchandisable": true,
		"raw": false,
		"date": 1928,
		"cost": 340,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Baby Food",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 4540,
		"totalProfit": 13590,
		"composition": [
			"Milk"
		],
		"isWorthIt": true,
		"price": 14150,
		"totalCost": 560,
		"index": 5
	},
	{
		"profit": 20410,
		"merchandisable": true,
		"raw": false,
		"date": 1961,
		"cost": 640,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Baby Nappies",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 350,
		"totalProfit": 20410,
		"composition": [
			"Cotton"
		],
		"isWorthIt": true,
		"price": 21230,
		"totalCost": 820,
		"index": 6
	},
	{
		"profit": 5480,
		"merchandisable": true,
		"raw": false,
		"date": 1913,
		"cost": 360,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Baker's Ware",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 310,
		"totalProfit": 5480,
		"composition": [
			"Wheat"
		],
		"isWorthIt": true,
		"price": 6000,
		"totalCost": 520,
		"index": 7
	},
	{
		"profit": -420,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 420,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Bauxite",
		"soldAt": "NOPE",
		"manufacturedAt": "Mine",
		"ingredientsWorth": 0,
		"totalProfit": -420,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 420,
		"index": 8
	},
	{
		"profit": 12100,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 690,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Beer",
		"soldAt": "Grocery",
		"manufacturedAt": "Brewery",
		"ingredientsWorth": 10620,
		"totalProfit": 12100,
		"composition": [
			"Glass",
			"Hops"
		],
		"isWorthIt": true,
		"price": 13610,
		"totalCost": 1510,
		"index": 9
	},
	{
		"profit": 18390,
		"merchandisable": true,
		"raw": false,
		"date": 1922,
		"cost": 3360,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Bikes",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 3000,
		"totalProfit": 18390,
		"composition": [
			"Steel"
		],
		"isWorthIt": true,
		"price": 23000,
		"totalCost": 4610,
		"index": 10
	},
	{
		"profit": 48490,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 1000,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Bio Fuel",
		"soldAt": "Gas Station",
		"manufacturedAt": "Refinery",
		"ingredientsWorth": 0,
		"totalProfit": 48490,
		"composition": [
			"Rape"
		],
		"isWorthIt": true,
		"price": 50000,
		"totalCost": 1510,
		"index": 11
	},
	{
		"profit": 29350,
		"merchandisable": true,
		"raw": false,
		"date": 1930,
		"cost": 890,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Board Games",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 6980,
		"totalProfit": 29350,
		"composition": [
			"Cardboard",
			"Gambling Pieces"
		],
		"isWorthIt": true,
		"price": 33000,
		"totalCost": 3650,
		"index": 12
	},
	{
		"profit": -7750,
		"merchandisable": false,
		"raw": false,
		"date": 1935,
		"cost": 6500,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Body",
		"soldAt": "NOPE",
		"manufacturedAt": "Car Factory",
		"ingredientsWorth": 3000,
		"totalProfit": -7750,
		"composition": [
			"Steel"
		],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 7750,
		"index": 13
	},
	{
		"profit": 13080,
		"merchandisable": true,
		"raw": false,
		"date": 1922,
		"cost": 1280,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Bowling Balls",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 2540,
		"totalProfit": 13080,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 15380,
		"totalCost": 2300,
		"index": 14
	},
	{
		"profit": 26080,
		"merchandisable": true,
		"raw": false,
		"date": 1936,
		"cost": 1450,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Brass Instruments",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 3930,
		"totalProfit": 26080,
		"composition": [
			"High Grade Steel"
		],
		"isWorthIt": true,
		"price": 29070,
		"totalCost": 2990,
		"index": 15
	},
	{
		"profit": 4140,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 240,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Bread",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 310,
		"totalProfit": 4140,
		"composition": [
			"Wheat"
		],
		"isWorthIt": true,
		"price": 4540,
		"totalCost": 400,
		"index": 16
	},
	{
		"profit": 13300,
		"merchandisable": true,
		"raw": false,
		"date": 1911,
		"cost": 980,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Calendar",
		"soldAt": "Book Shop",
		"manufacturedAt": "Book Shop",
		"ingredientsWorth": 13050,
		"totalProfit": 13300,
		"composition": [
			"Cardboard",
			"Paper"
		],
		"isWorthIt": true,
		"price": 16740,
		"totalCost": 3440,
		"index": 17
	},
	{
		"profit": 2510,
		"merchandisable": true,
		"raw": false,
		"date": 1934,
		"cost": 480,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Cans",
		"soldAt": "NOPE",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 3000,
		"totalProfit": 2510,
		"composition": [
			"Steel"
		],
		"isWorthIt": false,
		"price": 4240,
		"totalCost": 1730,
		"index": 18
	},
	{
		"profit": 5720,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 420,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Cardboard",
		"soldAt": "Book Shop",
		"manufacturedAt": "Paper Factory",
		"ingredientsWorth": 1770,
		"totalProfit": 5720,
		"composition": [
			"Grain Wood"
		],
		"isWorthIt": true,
		"price": 6980,
		"totalCost": 1260,
		"index": 19
	},
	{
		"profit": 9610,
		"merchandisable": true,
		"raw": false,
		"date": 1904,
		"cost": 670,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Cards",
		"soldAt": "Book Shop",
		"manufacturedAt": "Book Shop",
		"ingredientsWorth": 6980,
		"totalProfit": 9610,
		"composition": [
			"Cardboard"
		],
		"isWorthIt": true,
		"price": 11540,
		"totalCost": 1930,
		"index": 20
	},
	{
		"profit": 35210,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 920,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "CD",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 12770,
		"totalProfit": 35210,
		"composition": [
			"Plastics",
			"Glass"
		],
		"isWorthIt": true,
		"price": 37770,
		"totalCost": 2560,
		"index": 21
	},
	{
		"profit": 51720,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 3230,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "CD Player",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 20240,
		"totalProfit": 51720,
		"composition": [
			"Aluminum",
			"Electronic Components",
			"Plastics"
		],
		"isWorthIt": true,
		"price": 60000,
		"totalCost": 8280,
		"index": 22
	},
	{
		"profit": 17300,
		"merchandisable": true,
		"raw": false,
		"date": 1908,
		"cost": 2320,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Chairs",
		"soldAt": "Furniture",
		"manufacturedAt": "Furniture",
		"ingredientsWorth": 1930,
		"totalProfit": 17300,
		"composition": [
			"Leather",
			"Cut Wood"
		],
		"isWorthIt": true,
		"price": 20300,
		"totalCost": 3000,
		"index": 23
	},
	{
		"profit": 11962,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 710,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Chocolate",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 4540,
		"totalProfit": 11962,
		"composition": [
			"Cocoa Beans",
			"Milk"
		],
		"isWorthIt": true,
		"price": 23080,
		"totalCost": 11118,
		"index": 24
	},
	{
		"profit": 7780,
		"merchandisable": true,
		"raw": false,
		"date": 1913,
		"cost": 140,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Christmas Trees",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": 7780,
		"composition": [],
		"isWorthIt": true,
		"price": 7920,
		"totalCost": 140,
		"index": 25
	},
	{
		"profit": -10188,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 10188,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Cocoa Beans",
		"soldAt": "NOPE",
		"manufacturedAt": "Port",
		"ingredientsWorth": 0,
		"totalProfit": -10188,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 10188,
		"index": 26
	},
	{
		"profit": 9612,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 520,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Coffee",
		"soldAt": "Coffee Shop",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 0,
		"totalProfit": 9612,
		"composition": [
			"Coffee Beans"
		],
		"isWorthIt": true,
		"price": 19240,
		"totalCost": 9628,
		"index": 27
	},
	{
		"profit": -9108,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 9108,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Coffee Beans",
		"soldAt": "NOPE",
		"manufacturedAt": "Port",
		"ingredientsWorth": 0,
		"totalProfit": -9108,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 9108,
		"index": 28
	},
	{
		"profit": 41200,
		"merchandisable": true,
		"raw": false,
		"date": 1963,
		"cost": 2240,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Colour TV",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 48170,
		"totalProfit": 41200,
		"composition": [
			"Plastics",
			"Electronic Components",
			"Electronic Components",
			"Glass"
		],
		"isWorthIt": false,
		"price": 51460,
		"totalCost": 10260,
		"index": 29
	},
	{
		"profit": 22480,
		"merchandisable": true,
		"raw": false,
		"date": 1941,
		"cost": 780,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Comics",
		"soldAt": "Book Shop",
		"manufacturedAt": "Book Shop",
		"ingredientsWorth": 6070,
		"totalProfit": 22480,
		"composition": [
			"Paper"
		],
		"isWorthIt": true,
		"price": 24460,
		"totalCost": 1980,
		"index": 30
	},
	{
		"profit": 72850,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 3890,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Computer",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 40940,
		"totalProfit": 72850,
		"composition": [
			"Steel",
			"Electronic Components",
			"Electronic Components",
			"Plastics"
		],
		"isWorthIt": true,
		"price": 85390,
		"totalCost": 12540,
		"index": 31
	},
	{
		"profit": -520,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 520,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Copper Ore",
		"soldAt": "NOPE",
		"manufacturedAt": "Mine",
		"ingredientsWorth": 0,
		"totalProfit": -520,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 520,
		"index": 32
	},
	{
		"profit": -1280,
		"merchandisable": false,
		"raw": false,
		"date": 1925,
		"cost": 760,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Copper Wire",
		"soldAt": "NOPE",
		"manufacturedAt": "Forge",
		"ingredientsWorth": 0,
		"totalProfit": -1280,
		"composition": [
			"Copper Ore"
		],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 1280,
		"index": 33
	},
	{
		"profit": 6950,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 540,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Copybooks",
		"soldAt": "Book Shop",
		"manufacturedAt": "Book Shop",
		"ingredientsWorth": 6070,
		"totalProfit": 6950,
		"composition": [
			"Paper"
		],
		"isWorthIt": true,
		"price": 8690,
		"totalCost": 1740,
		"index": 34
	},
	{
		"profit": 170,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 180,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Cotton",
		"soldAt": "NOPE",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": 170,
		"composition": [],
		"isWorthIt": true,
		"price": 350,
		"totalCost": 180,
		"index": 35
	},
	{
		"profit": 16530,
		"merchandisable": true,
		"raw": false,
		"date": 1910,
		"cost": 2450,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Crank Telephone",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 6500,
		"totalProfit": 16530,
		"composition": [
			"Wooden Board",
			"Copper Wire"
		],
		"isWorthIt": true,
		"price": 21300,
		"totalCost": 4770,
		"index": 36
	},
	{
		"profit": 22120,
		"merchandisable": true,
		"raw": false,
		"date": 1936,
		"cost": 1090,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Crocodile Handbags",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 0,
		"totalProfit": 22120,
		"composition": [
			"Crocodile Leather"
		],
		"isWorthIt": true,
		"price": 23770,
		"totalCost": 1650,
		"index": 37
	},
	{
		"profit": -560,
		"merchandisable": false,
		"raw": true,
		"date": 1936,
		"cost": 560,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Crocodile Leather",
		"soldAt": "NOPE",
		"manufacturedAt": "Crocodile Farm",
		"ingredientsWorth": 0,
		"totalProfit": -560,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 560,
		"index": 38
	},
	{
		"profit": -320,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 320,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Cut Wood",
		"soldAt": "NOPE",
		"manufacturedAt": "Lumberyard",
		"ingredientsWorth": 0,
		"totalProfit": -320,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 320,
		"index": 39
	},
	{
		"profit": 14970,
		"merchandisable": true,
		"raw": false,
		"date": 1904,
		"cost": 2560,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Cutlery",
		"soldAt": "Home Appliances",
		"manufacturedAt": "Home Appliances",
		"ingredientsWorth": 3930,
		"totalProfit": 14970,
		"composition": [
			"High Grade Steel"
		],
		"isWorthIt": true,
		"price": 19070,
		"totalCost": 4100,
		"index": 40
	},
	{
		"profit": 11410,
		"merchandisable": true,
		"raw": false,
		"date": 1957,
		"cost": 570,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Dart Board",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 2540,
		"totalProfit": 11410,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 13000,
		"totalCost": 1590,
		"index": 41
	},
	{
		"profit": 23980,
		"merchandisable": true,
		"raw": false,
		"date": 1909,
		"cost": 3290,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Deep Freezer",
		"soldAt": "Home Appliances",
		"manufacturedAt": "Home Appliances",
		"ingredientsWorth": 6000,
		"totalProfit": 23980,
		"composition": [
			"Steel",
			"Steel"
		],
		"isWorthIt": true,
		"price": 29770,
		"totalCost": 5790,
		"index": 42
	},
	{
		"profit": -2040,
		"merchandisable": true,
		"raw": false,
		"date": 1943,
		"cost": -1,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Designer Furniture",
		"soldAt": "Furniture",
		"manufacturedAt": "Furniture",
		"ingredientsWorth": 1930,
		"totalProfit": -2040,
		"composition": [
			"Leather",
			"Aluminum",
			"Aluminum"
		],
		"isWorthIt": false,
		"price": -1,
		"totalCost": 2039,
		"index": 43
	},
	{
		"profit": 15630,
		"merchandisable": true,
		"raw": false,
		"date": 1938,
		"cost": 670,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Detergents",
		"soldAt": "Home Appliances",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 0,
		"totalProfit": 15630,
		"composition": [
			"Petroleum"
		],
		"isWorthIt": true,
		"price": 16840,
		"totalCost": 1210,
		"index": 44
	},
	{
		"profit": 60600,
		"merchandisable": true,
		"raw": false,
		"date": 2002,
		"cost": 2890,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Digital Decoder",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 24170,
		"totalProfit": 60600,
		"composition": [
			"High Grade Steel",
			"Electronic Components",
			"Plastics"
		],
		"isWorthIt": true,
		"price": 69240,
		"totalCost": 8640,
		"index": 45
	},
	{
		"profit": 16780,
		"merchandisable": true,
		"raw": false,
		"date": 1942,
		"cost": 1120,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Disposable Cups",
		"soldAt": "Home Appliances",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 2540,
		"totalProfit": 16780,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 18920,
		"totalCost": 2140,
		"index": 46
	},
	{
		"profit": 4560,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 720,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Dolls",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 2540,
		"totalProfit": 4560,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 6300,
		"totalCost": 1740,
		"index": 47
	},
	{
		"profit": 11270,
		"merchandisable": true,
		"raw": false,
		"date": 1903,
		"cost": 420,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Doughnuts",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 4850,
		"totalProfit": 11270,
		"composition": [
			"Wheat",
			"Milk"
		],
		"isWorthIt": true,
		"price": 12070,
		"totalCost": 800,
		"index": 48
	},
	{
		"profit": 10490,
		"merchandisable": true,
		"raw": false,
		"date": 1923,
		"cost": 820,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Drums",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 4930,
		"totalProfit": 10490,
		"composition": [
			"Leather",
			"Steel"
		],
		"isWorthIt": true,
		"price": 12920,
		"totalCost": 2430,
		"index": 49
	},
	{
		"profit": 54760,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 2570,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "DVD Player",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 20240,
		"totalProfit": 54760,
		"composition": [
			"Electronic Components",
			"Plastics"
		],
		"isWorthIt": true,
		"price": 61540,
		"totalCost": 6780,
		"index": 50
	},
	{
		"profit": 3970,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 180,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Eggs",
		"soldAt": "Grocery",
		"manufacturedAt": "Chicken Farm",
		"ingredientsWorth": 0,
		"totalProfit": 3970,
		"composition": [],
		"isWorthIt": true,
		"price": 4150,
		"totalCost": 180,
		"index": 51
	},
	{
		"profit": 108710,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 14790,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Electric Car",
		"soldAt": "Car Dealer",
		"manufacturedAt": "Car Factory",
		"ingredientsWorth": 35830,
		"totalProfit": 108710,
		"composition": [
			"Plastic Car Body",
			"Tyres",
			"Electric Engines"
		],
		"isWorthIt": true,
		"price": 142310,
		"totalCost": 33600,
		"index": 52
	},
	{
		"profit": 11880,
		"merchandisable": false,
		"raw": false,
		"date": 1927,
		"cost": 980,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Electric Engines",
		"soldAt": "NOPE",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 3000,
		"totalProfit": 11880,
		"composition": [
			"Steel",
			"Copper Wire"
		],
		"isWorthIt": true,
		"price": 15390,
		"totalCost": 3510,
		"index": 53
	},
	{
		"profit": 34550,
		"merchandisable": true,
		"raw": false,
		"date": 1947,
		"cost": 1540,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Electric Guitar",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 9500,
		"totalProfit": 34550,
		"composition": [
			"Wooden Board",
			"Steel"
		],
		"isWorthIt": true,
		"price": 38380,
		"totalCost": 3830,
		"index": 54
	},
	{
		"profit": 36630,
		"merchandisable": true,
		"raw": false,
		"date": 1938,
		"cost": 2130,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Electric Tools",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 20930,
		"totalProfit": 36630,
		"composition": [
			"Plastics",
			"Electric Engines",
			"Steel"
		],
		"isWorthIt": true,
		"price": 44540,
		"totalCost": 7910,
		"index": 55
	},
	{
		"profit": -4530,
		"merchandisable": true,
		"raw": false,
		"date": 1964,
		"cost": -1,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Electric Toothbrush",
		"soldAt": "Home Appliances",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 17930,
		"totalProfit": -4530,
		"composition": [
			"Plastics",
			"Electric Engines"
		],
		"isWorthIt": false,
		"price": -1,
		"totalCost": 4529,
		"index": 56
	},
	{
		"profit": 14510,
		"merchandisable": false,
		"raw": false,
		"date": 1925,
		"cost": 890,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Electronic Components",
		"soldAt": "NOPE",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 2540,
		"totalProfit": 14510,
		"composition": [
			"Plastics",
			"Copper Wire"
		],
		"isWorthIt": true,
		"price": 17700,
		"totalCost": 3190,
		"index": 57
	},
	{
		"profit": 80750,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 3140,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Electronic Pet",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 35630,
		"totalProfit": 80750,
		"composition": [
			"Plastics",
			"Electronic Components",
			"Electric Engines"
		],
		"isWorthIt": true,
		"price": 91610,
		"totalCost": 10860,
		"index": 58
	},
	{
		"profit": -6050,
		"merchandisable": false,
		"raw": false,
		"date": 1935,
		"cost": 4800,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Engines",
		"soldAt": "NOPE",
		"manufacturedAt": "Car Factory",
		"ingredientsWorth": 3000,
		"totalProfit": -6050,
		"composition": [
			"Steel"
		],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 6050,
		"index": 59
	},
	{
		"profit": 6900,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 840,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Fabrics",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 350,
		"totalProfit": 6900,
		"composition": [
			"Cotton"
		],
		"isWorthIt": true,
		"price": 7920,
		"totalCost": 1020,
		"index": 60
	},
	{
		"profit": 17920,
		"merchandisable": false,
		"raw": false,
		"date": 1955,
		"cost": 3700,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Fashion Jewellery",
		"soldAt": "Jewellery",
		"manufacturedAt": "Jewellery Factory",
		"ingredientsWorth": 10230,
		"totalProfit": 17920,
		"composition": [
			"Aluminum",
			"Glass"
		],
		"isWorthIt": true,
		"price": 23080,
		"totalCost": 5160,
		"index": 61
	},
	{
		"profit": 6480,
		"merchandisable": true,
		"raw": true,
		"date": 1955,
		"cost": 490,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Fish",
		"soldAt": "Grocery",
		"manufacturedAt": "Fishmonger",
		"ingredientsWorth": 0,
		"totalProfit": 6480,
		"composition": [],
		"isWorthIt": true,
		"price": 6970,
		"totalCost": 490,
		"index": 62
	},
	{
		"profit": 34170,
		"merchandisable": true,
		"raw": false,
		"date": 1955,
		"cost": 1190,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Fishing",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 2770,
		"totalProfit": 34170,
		"composition": [
			"Aluminum",
			"Nylon"
		],
		"isWorthIt": true,
		"price": 37460,
		"totalCost": 3290,
		"index": 63
	},
	{
		"profit": 23060,
		"merchandisable": true,
		"raw": false,
		"date": 1945,
		"cost": 3840,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Fitness Appliances",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 3000,
		"totalProfit": 23060,
		"composition": [
			"Steel"
		],
		"isWorthIt": true,
		"price": 28150,
		"totalCost": 5090,
		"index": 64
	},
	{
		"profit": 18000,
		"merchandisable": true,
		"raw": false,
		"date": 1926,
		"cost": 560,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Footballs",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 1930,
		"totalProfit": 18000,
		"composition": [
			"Leather"
		],
		"isWorthIt": true,
		"price": 18920,
		"totalCost": 920,
		"index": 65
	},
	{
		"profit": 30870,
		"merchandisable": true,
		"raw": false,
		"date": 1928,
		"cost": 1890,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Friction Train",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 3930,
		"totalProfit": 30870,
		"composition": [
			"High Grade Steel"
		],
		"isWorthIt": true,
		"price": 34300,
		"totalCost": 3430,
		"index": 66
	},
	{
		"profit": 30330,
		"merchandisable": true,
		"raw": false,
		"date": 1927,
		"cost": 4890,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Fridge",
		"soldAt": "Home Appliances",
		"manufacturedAt": "Home Appliances",
		"ingredientsWorth": 20930,
		"totalProfit": 30330,
		"composition": [
			"Plastics",
			"Electric Engines",
			"Steel"
		],
		"isWorthIt": true,
		"price": 41000,
		"totalCost": 10670,
		"index": 67
	},
	{
		"profit": -1340,
		"merchandisable": true,
		"raw": false,
		"date": 1954,
		"cost": -1,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Frozen Foods",
		"soldAt": "Grocery",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 7770,
		"totalProfit": -1340,
		"composition": [
			"Meat",
			"Plastics"
		],
		"isWorthIt": false,
		"price": -1,
		"totalCost": 1339,
		"index": 68
	},
	{
		"profit": 5720,
		"merchandisable": true,
		"raw": true,
		"date": 1900,
		"cost": 280,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Fruit",
		"soldAt": "Grocery",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": 5720,
		"composition": [],
		"isWorthIt": true,
		"price": 6000,
		"totalCost": 280,
		"index": 69
	},
	{
		"profit": 8200,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 540,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Fruit Juice",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 22230,
		"totalProfit": 8200,
		"composition": [
			"Fruit",
			"Fruit",
			"Glass"
		],
		"isWorthIt": false,
		"price": 9920,
		"totalCost": 1720,
		"index": 70
	},
	{
		"profit": 25790,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 600,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Fuel",
		"soldAt": "Gas Station",
		"manufacturedAt": "Refinery",
		"ingredientsWorth": 0,
		"totalProfit": 25790,
		"composition": [
			"Petroleum"
		],
		"isWorthIt": true,
		"price": 26930,
		"totalCost": 1140,
		"index": 71
	},
	{
		"profit": 12960,
		"merchandisable": true,
		"raw": false,
		"date": 1902,
		"cost": 870,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Furry Pets",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 9690,
		"totalProfit": 12960,
		"composition": [
			"Fabrics",
			"Grain Wood"
		],
		"isWorthIt": true,
		"price": 15690,
		"totalCost": 2730,
		"index": 72
	},
	{
		"profit": 48440,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 1200,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Gamatotchi",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 20240,
		"totalProfit": 48440,
		"composition": [
			"Plastics",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 53850,
		"totalCost": 5410,
		"index": 73
	},
	{
		"profit": -1500,
		"merchandisable": false,
		"raw": false,
		"date": 1919,
		"cost": 460,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Gambling Pieces",
		"soldAt": "NOPE",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 6500,
		"totalProfit": -1500,
		"composition": [
			"Wooden Board"
		],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 1500,
		"index": 74
	},
	{
		"profit": 55230,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 2100,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Gamegirl",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 20240,
		"totalProfit": 55230,
		"composition": [
			"Plastics",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 61540,
		"totalCost": 6310,
		"index": 75
	},
	{
		"profit": -1020,
		"merchandisable": true,
		"raw": false,
		"date": 1962,
		"cost": -1,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Garden Furniture (Plastic)",
		"soldAt": "Furniture",
		"manufacturedAt": "Furniture",
		"ingredientsWorth": 2540,
		"totalProfit": -1020,
		"composition": [
			"Plastics"
		],
		"isWorthIt": false,
		"price": -1,
		"totalCost": 1019,
		"index": 76
	},
	{
		"profit": 12380,
		"merchandisable": true,
		"raw": false,
		"date": 1962,
		"cost": 960,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Garden Furniture (Wooden)",
		"soldAt": "Furniture",
		"manufacturedAt": "Furniture",
		"ingredientsWorth": 6500,
		"totalProfit": 12380,
		"composition": [
			"Wooden Board"
		],
		"isWorthIt": true,
		"price": 14380,
		"totalCost": 2000,
		"index": 77
	},
	{
		"profit": 19290,
		"merchandisable": true,
		"raw": false,
		"date": 1933,
		"cost": 990,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Garden Gnome",
		"soldAt": "Home Hardware",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 2540,
		"totalProfit": 19290,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 21300,
		"totalCost": 2010,
		"index": 78
	},
	{
		"profit": 14340,
		"merchandisable": true,
		"raw": false,
		"date": 1912,
		"cost": 840,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Garden Houses",
		"soldAt": "Furniture",
		"manufacturedAt": "Furniture",
		"ingredientsWorth": 19500,
		"totalProfit": 14340,
		"composition": [
			"Wooden Board",
			"Wooden Board",
			"Wooden Board"
		],
		"isWorthIt": false,
		"price": 18300,
		"totalCost": 3960,
		"index": 79
	},
	{
		"profit": 10700,
		"merchandisable": true,
		"raw": false,
		"date": 1916,
		"cost": 600,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Gift Wrapping",
		"soldAt": "Book Shop",
		"manufacturedAt": "Book Shop",
		"ingredientsWorth": 6070,
		"totalProfit": 10700,
		"composition": [
			"Paper"
		],
		"isWorthIt": true,
		"price": 12500,
		"totalCost": 1800,
		"index": 80
	},
	{
		"profit": 9610,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 360,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Glass",
		"soldAt": "Home Appliances",
		"manufacturedAt": "Glassmaker",
		"ingredientsWorth": 0,
		"totalProfit": 9610,
		"composition": [
			"Quartz Sand"
		],
		"isWorthIt": true,
		"price": 10230,
		"totalCost": 620,
		"index": 81
	},
	{
		"profit": -6708,
		"merchandisable": false,
		"raw": true,
		"date": 1955,
		"cost": 6708,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Gold",
		"soldAt": "NOPE",
		"manufacturedAt": "Port",
		"ingredientsWorth": 0,
		"totalProfit": -6708,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 6708,
		"index": 82
	},
	{
		"profit": 17562,
		"merchandisable": false,
		"raw": false,
		"date": 1955,
		"cost": 6500,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Gold Jewellery",
		"soldAt": "NOPE",
		"manufacturedAt": "Jewellery Factory",
		"ingredientsWorth": 0,
		"totalProfit": 17562,
		"composition": [
			"Gold"
		],
		"isWorthIt": true,
		"price": 30770,
		"totalCost": 13208,
		"index": 83
	},
	{
		"profit": 930,
		"merchandisable": false,
		"raw": false,
		"date": 1900,
		"cost": 520,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Grain Wood",
		"soldAt": "NOPE",
		"manufacturedAt": "Sawmill",
		"ingredientsWorth": 0,
		"totalProfit": 930,
		"composition": [
			"Cut Wood"
		],
		"isWorthIt": true,
		"price": 1770,
		"totalCost": 840,
		"index": 84
	},
	{
		"profit": 5920,
		"merchandisable": true,
		"raw": true,
		"date": 1900,
		"cost": 1000,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Grapes",
		"soldAt": "Grocery",
		"manufacturedAt": "Vineyard",
		"ingredientsWorth": 0,
		"totalProfit": 5920,
		"composition": [],
		"isWorthIt": true,
		"price": 6920,
		"totalCost": 1000,
		"index": 85
	},
	{
		"profit": 35630,
		"merchandisable": true,
		"raw": false,
		"date": 1951,
		"cost": 1290,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Gril",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 3930,
		"totalProfit": 35630,
		"composition": [
			"High Grade Steel"
		],
		"isWorthIt": true,
		"price": 38460,
		"totalCost": 2830,
		"index": 86
	},
	{
		"profit": 18620,
		"merchandisable": true,
		"raw": false,
		"date": 1918,
		"cost": 1240,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Guitar",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 9500,
		"totalProfit": 18620,
		"composition": [
			"Wooden Board",
			"Steel"
		],
		"isWorthIt": true,
		"price": 22150,
		"totalCost": 3530,
		"index": 87
	},
	{
		"profit": 24330,
		"merchandisable": true,
		"raw": false,
		"date": 1933,
		"cost": 980,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Hairdryer",
		"soldAt": "Home Appliances",
		"manufacturedAt": "Home Appliances",
		"ingredientsWorth": 17930,
		"totalProfit": 24330,
		"composition": [
			"Plastics",
			"Electric Engines"
		],
		"isWorthIt": true,
		"price": 29840,
		"totalCost": 5510,
		"index": 88
	},
	{
		"profit": 15870,
		"merchandisable": true,
		"raw": false,
		"date": 1924,
		"cost": 560,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Hamburgers",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 9770,
		"totalProfit": 15870,
		"composition": [
			"Bread",
			"Meat"
		],
		"isWorthIt": true,
		"price": 17150,
		"totalCost": 1280,
		"index": 89
	},
	{
		"profit": 30840,
		"merchandisable": true,
		"raw": false,
		"date": 1929,
		"cost": 1890,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Hand Mower",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 3000,
		"totalProfit": 30840,
		"composition": [
			"Cut Wood",
			"Steel"
		],
		"isWorthIt": true,
		"price": 34300,
		"totalCost": 3460,
		"index": 90
	},
	{
		"profit": 10820,
		"merchandisable": true,
		"raw": false,
		"date": 1919,
		"cost": 980,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Handbags",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 1930,
		"totalProfit": 10820,
		"composition": [
			"Leather"
		],
		"isWorthIt": true,
		"price": 12160,
		"totalCost": 1340,
		"index": 91
	},
	{
		"profit": 40960,
		"merchandisable": true,
		"raw": false,
		"date": 1956,
		"cost": 1670,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "HiFi Unit",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 20240,
		"totalProfit": 40960,
		"composition": [
			"Plastics",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 46840,
		"totalCost": 5880,
		"index": 92
	},
	{
		"profit": 2390,
		"merchandisable": false,
		"raw": false,
		"date": 1904,
		"cost": 980,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "High Grade Steel",
		"soldAt": "NOPE",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 0,
		"totalProfit": 2390,
		"composition": [
			"Precious Metals"
		],
		"isWorthIt": true,
		"price": 3930,
		"totalCost": 1540,
		"index": 93
	},
	{
		"profit": 87520,
		"merchandisable": true,
		"raw": false,
		"date": 2008,
		"cost": 3990,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Home Cinema",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 27930,
		"totalProfit": 87520,
		"composition": [
			"Aluminum",
			"Electronic Components",
			"Glass"
		],
		"isWorthIt": true,
		"price": 96160,
		"totalCost": 8640,
		"index": 94
	},
	{
		"profit": 190,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 200,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Hops",
		"soldAt": "NOPE",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 0,
		"totalProfit": 190,
		"composition": [],
		"isWorthIt": true,
		"price": 390,
		"totalCost": 200,
		"index": 95
	},
	{
		"profit": 24150,
		"merchandisable": true,
		"raw": false,
		"date": 1940,
		"cost": 1440,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Inflatable Boat",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 2390,
		"totalProfit": 24150,
		"composition": [
			"Rubber"
		],
		"isWorthIt": true,
		"price": 26690,
		"totalCost": 2540,
		"index": 96
	},
	{
		"profit": -400,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 400,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Iron Ore",
		"soldAt": "NOPE",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 0,
		"totalProfit": -400,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 400,
		"index": 97
	},
	{
		"profit": 26140,
		"merchandisable": true,
		"raw": false,
		"date": 1954,
		"cost": 1300,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Jeans",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 7920,
		"totalProfit": 26140,
		"composition": [
			"Fabrics"
		],
		"isWorthIt": true,
		"price": 28460,
		"totalCost": 2320,
		"index": 98
	},
	{
		"profit": 7070,
		"merchandisable": true,
		"raw": false,
		"date": 1909,
		"cost": 680,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Joke Articles",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 2540,
		"totalProfit": 7070,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 8770,
		"totalCost": 1700,
		"index": 99
	},
	{
		"profit": 40350,
		"merchandisable": true,
		"raw": false,
		"date": 1953,
		"cost": 2190,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Juke Box",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 23240,
		"totalProfit": 40350,
		"composition": [
			"Plastics",
			"Electronic Components",
			"Steel"
		],
		"isWorthIt": true,
		"price": 48000,
		"totalCost": 7650,
		"index": 100
	},
	{
		"profit": 15740,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 620,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Ketchup",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 10220,
		"totalProfit": 15740,
		"composition": [
			"Tomatoes",
			"Plastics"
		],
		"isWorthIt": true,
		"price": 17700,
		"totalCost": 1960,
		"index": 101
	},
	{
		"profit": 58880,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 2370,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Keyboard",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 20240,
		"totalProfit": 58880,
		"composition": [
			"Plastics",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 65460,
		"totalCost": 6580,
		"index": 102
	},
	{
		"profit": 36500,
		"merchandisable": true,
		"raw": false,
		"date": 1955,
		"cost": 1290,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Kitchen Device",
		"soldAt": "Home Appliances",
		"manufacturedAt": "Home Appliances",
		"ingredientsWorth": 17930,
		"totalProfit": 36500,
		"composition": [
			"Plastics",
			"Electric Engines"
		],
		"isWorthIt": true,
		"price": 42320,
		"totalCost": 5820,
		"index": 103
	},
	{
		"profit": 1570,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 360,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Leather",
		"soldAt": "NOPE",
		"manufacturedAt": "Cow Farm",
		"ingredientsWorth": 0,
		"totalProfit": 1570,
		"composition": [],
		"isWorthIt": true,
		"price": 1930,
		"totalCost": 360,
		"index": 104
	},
	{
		"profit": 12570,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 660,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Lightbulb",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 14160,
		"totalProfit": 12570,
		"composition": [
			"Glass",
			"High Grade Steel"
		],
		"isWorthIt": false,
		"price": 15390,
		"totalCost": 2820,
		"index": 105
	},
	{
		"profit": -11310,
		"merchandisable": false,
		"raw": false,
		"date": 1944,
		"cost": 8450,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Luxury Body",
		"soldAt": "NOPE",
		"manufacturedAt": "Car Factory",
		"ingredientsWorth": 7930,
		"totalProfit": -11310,
		"composition": [
			"Steel",
			"Steel",
			"Leather"
		],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 11310,
		"index": 106
	},
	{
		"profit": 96530,
		"merchandisable": true,
		"raw": false,
		"date": 1944,
		"cost": 15670,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Luxury Motor Car",
		"soldAt": "Car Dealer",
		"manufacturedAt": "Car Factory",
		"ingredientsWorth": 20440,
		"totalProfit": 96530,
		"composition": [
			"Luxury Body",
			"Tyres",
			"Engines"
		],
		"isWorthIt": true,
		"price": 134300,
		"totalCost": 37770,
		"index": 107
	},
	{
		"profit": 7360,
		"merchandisable": true,
		"raw": true,
		"date": 1900,
		"cost": 380,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Maize",
		"soldAt": "Grocery",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": 7360,
		"composition": [],
		"isWorthIt": true,
		"price": 7740,
		"totalCost": 380,
		"index": 108
	},
	{
		"profit": 4910,
		"merchandisable": true,
		"raw": true,
		"date": 1900,
		"cost": 320,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Meat",
		"soldAt": "Grocery",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": 4910,
		"composition": [],
		"isWorthIt": true,
		"price": 5230,
		"totalCost": 320,
		"index": 109
	},
	{
		"profit": 8870,
		"merchandisable": true,
		"raw": false,
		"date": 1915,
		"cost": 720,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Metal Cars",
		"soldAt": "Toys",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 3000,
		"totalProfit": 8870,
		"composition": [
			"Steel"
		],
		"isWorthIt": true,
		"price": 10840,
		"totalCost": 1970,
		"index": 110
	},
	{
		"profit": -4030,
		"merchandisable": true,
		"raw": false,
		"date": 1968,
		"cost": -1,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Microwave",
		"soldAt": "Home Appliances",
		"manufacturedAt": "Home Appliances",
		"ingredientsWorth": 17700,
		"totalProfit": -4030,
		"composition": [
			"Aluminum",
			"Electronic Components"
		],
		"isWorthIt": false,
		"price": -1,
		"totalCost": 4029,
		"index": 111
	},
	{
		"profit": 4320,
		"merchandisable": true,
		"raw": true,
		"date": 1900,
		"cost": 220,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Milk",
		"soldAt": "Grocery",
		"manufacturedAt": "Cow Farm",
		"ingredientsWorth": 0,
		"totalProfit": 4320,
		"composition": [],
		"isWorthIt": true,
		"price": 4540,
		"totalCost": 220,
		"index": 112
	},
	{
		"profit": 44780,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 1780,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Mobile Phone",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 20240,
		"totalProfit": 44780,
		"composition": [
			"Electronic Components",
			"Plastics"
		],
		"isWorthIt": true,
		"price": 50770,
		"totalCost": 5990,
		"index": 113
	},
	{
		"profit": 33880,
		"merchandisable": true,
		"raw": false,
		"date": 1952,
		"cost": 2290,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Model Railroad",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 20240,
		"totalProfit": 33880,
		"composition": [
			"Plastics",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 40380,
		"totalCost": 6500,
		"index": 114
	},
	{
		"profit": 54390,
		"merchandisable": true,
		"raw": false,
		"date": 1935,
		"cost": 12450,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Motor Car",
		"soldAt": "Car Dealer",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 20440,
		"totalProfit": 54390,
		"composition": [
			"Body",
			"Tyres",
			"Engines"
		],
		"isWorthIt": true,
		"price": 85380,
		"totalCost": 30990,
		"index": 115
	},
	{
		"profit": 12580,
		"merchandisable": true,
		"raw": false,
		"date": 1941,
		"cost": 780,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Mouth Organ",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 3000,
		"totalProfit": 12580,
		"composition": [
			"Steel"
		],
		"isWorthIt": true,
		"price": 14610,
		"totalCost": 2030,
		"index": 116
	},
	{
		"profit": 53600,
		"merchandisable": true,
		"raw": false,
		"date": 2005,
		"cost": 2190,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "MP3 Player",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 20240,
		"totalProfit": 53600,
		"composition": [
			"Plastics",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 60000,
		"totalCost": 6400,
		"index": 117
	},
	{
		"profit": 6820,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 750,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Newspaper",
		"soldAt": "Book Shop",
		"manufacturedAt": "Book Shop",
		"ingredientsWorth": 6070,
		"totalProfit": 6820,
		"composition": [
			"Paper"
		],
		"isWorthIt": true,
		"price": 8770,
		"totalCost": 1950,
		"index": 118
	},
	{
		"profit": 1510,
		"merchandisable": false,
		"raw": false,
		"date": 1939,
		"cost": 720,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Nylon",
		"soldAt": "NOPE",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 0,
		"totalProfit": 1510,
		"composition": [
			"Petroleum"
		],
		"isWorthIt": true,
		"price": 2770,
		"totalCost": 1260,
		"index": 119
	},
	{
		"profit": 17030,
		"merchandisable": true,
		"raw": false,
		"date": 1939,
		"cost": 780,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Nylon Tights",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 2770,
		"totalProfit": 17030,
		"composition": [
			"Nylon"
		],
		"isWorthIt": true,
		"price": 19070,
		"totalCost": 2040,
		"index": 120
	},
	{
		"profit": 16920,
		"merchandisable": true,
		"raw": false,
		"date": 1946,
		"cost": 720,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Nylon Toothbrush",
		"soldAt": "Home Appliances",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 5310,
		"totalProfit": 16920,
		"composition": [
			"Plastics",
			"Nylon"
		],
		"isWorthIt": true,
		"price": 19920,
		"totalCost": 3000,
		"index": 121
	},
	{
		"profit": 34160,
		"merchandisable": true,
		"raw": false,
		"date": 1931,
		"cost": 2780,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Office Furniture",
		"soldAt": "Furniture",
		"manufacturedAt": "Furniture",
		"ingredientsWorth": 9500,
		"totalProfit": 34160,
		"composition": [
			"Wooden Board",
			"Steel"
		],
		"isWorthIt": true,
		"price": 39230,
		"totalCost": 5070,
		"index": 122
	},
	{
		"profit": 4870,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 360,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Paper",
		"soldAt": "Book Shop",
		"manufacturedAt": "Paper Factory",
		"ingredientsWorth": 1770,
		"totalProfit": 4870,
		"composition": [
			"Grain Wood"
		],
		"isWorthIt": true,
		"price": 6070,
		"totalCost": 1200,
		"index": 123
	},
	{
		"profit": 14630,
		"merchandisable": true,
		"raw": false,
		"date": 1917,
		"cost": 550,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Peanut Butter",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 4840,
		"totalProfit": 14630,
		"composition": [
			"Peanuts",
			"Milk"
		],
		"isWorthIt": true,
		"price": 15540,
		"totalCost": 910,
		"index": 124
	},
	{
		"profit": 160,
		"merchandisable": false,
		"raw": true,
		"date": 1905,
		"cost": 140,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Peanuts",
		"soldAt": "NOPE",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": 160,
		"composition": [],
		"isWorthIt": true,
		"price": 300,
		"totalCost": 140,
		"index": 125
	},
	{
		"profit": -540,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 540,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Petroleum",
		"soldAt": "NOPE",
		"manufacturedAt": "Oil Derelict",
		"ingredientsWorth": 0,
		"totalProfit": -540,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 540,
		"index": 126
	},
	{
		"profit": 35610,
		"merchandisable": true,
		"raw": false,
		"date": 1926,
		"cost": 3250,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Piano",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 9500,
		"totalProfit": 35610,
		"composition": [
			"Wooden Board",
			"Steel"
		],
		"isWorthIt": true,
		"price": 41150,
		"totalCost": 5540,
		"index": 127
	},
	{
		"profit": 6400,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 480,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Picture Frame",
		"soldAt": "Furniture",
		"manufacturedAt": "Furniture",
		"ingredientsWorth": 6500,
		"totalProfit": 6400,
		"composition": [
			"Wooden Board"
		],
		"isWorthIt": false,
		"price": 7920,
		"totalCost": 1520,
		"index": 128
	},
	{
		"profit": 26800,
		"merchandisable": true,
		"raw": false,
		"date": 1949,
		"cost": 1430,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Pinball Machine",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 12040,
		"totalProfit": 26800,
		"composition": [
			"Wooden Board",
			"Steel",
			"Plastics"
		],
		"isWorthIt": true,
		"price": 31540,
		"totalCost": 4740,
		"index": 129
	},
	{
		"profit": 21470,
		"merchandisable": true,
		"raw": false,
		"date": 1950,
		"cost": 1280,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Plastic Boxes",
		"soldAt": "Home Appliances",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 2540,
		"totalProfit": 21470,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 23770,
		"totalCost": 2300,
		"index": 130
	},
	{
		"profit": 25480,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 500,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Plastic Bricks",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 2540,
		"totalProfit": 25480,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 27000,
		"totalCost": 1520,
		"index": 131
	},
	{
		"profit": -10560,
		"merchandisable": false,
		"raw": false,
		"date": 1000,
		"cost": 7500,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Plastic Car Body",
		"soldAt": "NOPE",
		"manufacturedAt": "Car Factory",
		"ingredientsWorth": 7620,
		"totalProfit": -10560,
		"composition": [
			"Plastics",
			"Plastics",
			"Plastics"
		],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 10560,
		"index": 132
	},
	{
		"profit": 12100,
		"merchandisable": true,
		"raw": false,
		"date": 1937,
		"cost": 720,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Plastic Cars",
		"soldAt": "Toys",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 2540,
		"totalProfit": 12100,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 13840,
		"totalCost": 1740,
		"index": 133
	},
	{
		"profit": 16460,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 750,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Plastic Discus",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 2540,
		"totalProfit": 16460,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 18230,
		"totalCost": 1770,
		"index": 134
	},
	{
		"profit": 1520,
		"merchandisable": false,
		"raw": false,
		"date": 1900,
		"cost": 480,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Plastics",
		"soldAt": "NOPE",
		"manufacturedAt": "Chemical Plant",
		"ingredientsWorth": 0,
		"totalProfit": 1520,
		"composition": [
			"Petroleum"
		],
		"isWorthIt": true,
		"price": 2540,
		"totalCost": 1020,
		"index": 135
	},
	{
		"profit": 5890,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 660,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Popcorn",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 7740,
		"totalProfit": 5890,
		"composition": [
			"Maize"
		],
		"isWorthIt": false,
		"price": 6930,
		"totalCost": 1040,
		"index": 136
	},
	{
		"profit": 14100,
		"merchandisable": true,
		"raw": false,
		"date": 1924,
		"cost": 700,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Posters",
		"soldAt": "Book Shop",
		"manufacturedAt": "Book Shop",
		"ingredientsWorth": 6070,
		"totalProfit": 14100,
		"composition": [
			"Paper"
		],
		"isWorthIt": true,
		"price": 16000,
		"totalCost": 1900,
		"index": 137
	},
	{
		"profit": 7480,
		"merchandisable": true,
		"raw": true,
		"date": 1900,
		"cost": 360,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Potatoes",
		"soldAt": "NOPE",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": 7480,
		"composition": [],
		"isWorthIt": true,
		"price": 7840,
		"totalCost": 360,
		"index": 138
	},
	{
		"profit": 17420,
		"merchandisable": true,
		"raw": false,
		"date": 1932,
		"cost": 690,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Potato Crisps",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 7840,
		"totalProfit": 17420,
		"composition": [
			"Potatoes"
		],
		"isWorthIt": true,
		"price": 18470,
		"totalCost": 1050,
		"index": 139
	},
	{
		"profit": 49550,
		"merchandisable": true,
		"raw": false,
		"date": 1960,
		"cost": 3590,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Power Mower",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 5390,
		"totalProfit": 49550,
		"composition": [
			"Steel",
			"Engines",
			"Rubber"
		],
		"isWorthIt": true,
		"price": 61540,
		"totalCost": 11990,
		"index": 140
	},
	{
		"profit": -560,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 560,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Precious Metals",
		"soldAt": "NOPE",
		"manufacturedAt": "Mine",
		"ingredientsWorth": 0,
		"totalProfit": -560,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 560,
		"index": 141
	},
	{
		"profit": 21780,
		"merchandisable": true,
		"raw": false,
		"date": 1955,
		"cost": 920,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Preserved Fish",
		"soldAt": "Grocery",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 11210,
		"totalProfit": 21780,
		"composition": [
			"Fish",
			"Cans"
		],
		"isWorthIt": true,
		"price": 24920,
		"totalCost": 3140,
		"index": 142
	},
	{
		"profit": 22150,
		"merchandisable": true,
		"raw": false,
		"date": 1934,
		"cost": 760,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Preserved Fruit",
		"soldAt": "Grocery",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 10240,
		"totalProfit": 22150,
		"composition": [
			"Fruit",
			"Cans"
		],
		"isWorthIt": true,
		"price": 24920,
		"totalCost": 2770,
		"index": 143
	},
	{
		"profit": 22000,
		"merchandisable": true,
		"raw": false,
		"date": 1934,
		"cost": 870,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Preserved Meat",
		"soldAt": "Grocery",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 9470,
		"totalProfit": 22000,
		"composition": [
			"Meat",
			"Cans"
		],
		"isWorthIt": true,
		"price": 24920,
		"totalCost": 2920,
		"index": 144
	},
	{
		"profit": 42320,
		"merchandisable": true,
		"raw": false,
		"date": 1966,
		"cost": 1470,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Push Button Phone",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 20240,
		"totalProfit": 42320,
		"composition": [
			"Plastics",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 48000,
		"totalCost": 5680,
		"index": 145
	},
	{
		"profit": 17530,
		"merchandisable": true,
		"raw": false,
		"date": 1906,
		"cost": 2190,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Push Cart",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 5390,
		"totalProfit": 17530,
		"composition": [
			"Steel",
			"Rubber"
		],
		"isWorthIt": true,
		"price": 22070,
		"totalCost": 4540,
		"index": 146
	},
	{
		"profit": -260,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 260,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Quartz Sand",
		"soldAt": "NOPE",
		"manufacturedAt": "Mine",
		"ingredientsWorth": 0,
		"totalProfit": -260,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 260,
		"index": 147
	},
	{
		"profit": 24690,
		"merchandisable": true,
		"raw": false,
		"date": 1925,
		"cost": 1850,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Radio",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 24200,
		"totalProfit": 24690,
		"composition": [
			"Wooden Board",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 30770,
		"totalCost": 6080,
		"index": 148
	},
	{
		"profit": -1100,
		"merchandisable": true,
		"raw": false,
		"date": 1912,
		"cost": -1,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Raincoat",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 2390,
		"totalProfit": -1100,
		"composition": [
			"Rubber"
		],
		"isWorthIt": false,
		"price": -1,
		"totalCost": 1099,
		"index": 149
	},
	{
		"profit": -510,
		"merchandisable": false,
		"raw": true,
		"date": 1000,
		"cost": 510,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Rape",
		"soldAt": "NOPE",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": -510,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 510,
		"index": 150
	},
	{
		"profit": 42110,
		"merchandisable": true,
		"raw": false,
		"date": 1968,
		"cost": 1980,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "RC Cars",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 20240,
		"totalProfit": 42110,
		"composition": [
			"Plastics",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 48300,
		"totalCost": 6190,
		"index": 151
	},
	{
		"profit": 20790,
		"merchandisable": true,
		"raw": false,
		"date": 1948,
		"cost": 1050,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Record",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 0,
		"totalProfit": 20790,
		"composition": [
			"Petroleum"
		],
		"isWorthIt": true,
		"price": 22380,
		"totalCost": 1590,
		"index": 152
	},
	{
		"profit": 9650,
		"merchandisable": true,
		"raw": false,
		"date": 1916,
		"cost": 690,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Recorder",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 6500,
		"totalProfit": 9650,
		"composition": [
			"Wooden Board"
		],
		"isWorthIt": true,
		"price": 11380,
		"totalCost": 1730,
		"index": 153
	},
	{
		"profit": 9920,
		"merchandisable": true,
		"raw": false,
		"date": 1905,
		"cost": 320,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Roasted Peanuts",
		"soldAt": "Grocery",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 300,
		"totalProfit": 9920,
		"composition": [
			"Peanuts"
		],
		"isWorthIt": true,
		"price": 10380,
		"totalCost": 460,
		"index": 154
	},
	{
		"profit": 27500,
		"merchandisable": true,
		"raw": false,
		"date": 1932,
		"cost": 890,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Roller Skates",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 4930,
		"totalProfit": 27500,
		"composition": [
			"Leather",
			"Steel"
		],
		"isWorthIt": true,
		"price": 30000,
		"totalCost": 2500,
		"index": 155
	},
	{
		"profit": 1290,
		"merchandisable": false,
		"raw": false,
		"date": 1900,
		"cost": 560,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Rubber",
		"soldAt": "NOPE",
		"manufacturedAt": "Chemical Plant",
		"ingredientsWorth": 0,
		"totalProfit": 1290,
		"composition": [
			"Petroleum"
		],
		"isWorthIt": true,
		"price": 2390,
		"totalCost": 1100,
		"index": 156
	},
	{
		"profit": 35270,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 1340,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Satellite Receiver",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 2540,
		"totalProfit": 35270,
		"composition": [
			"Aluminum",
			"Plastics"
		],
		"isWorthIt": true,
		"price": 38470,
		"totalCost": 3200,
		"index": 157
	},
	{
		"profit": 13140,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 1400,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Shoes",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 4320,
		"totalProfit": 13140,
		"composition": [
			"Leather",
			"Rubber"
		],
		"isWorthIt": true,
		"price": 16000,
		"totalCost": 2860,
		"index": 158
	},
	{
		"profit": -5748,
		"merchandisable": false,
		"raw": true,
		"date": 1955,
		"cost": 5748,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Silver",
		"soldAt": "NOPE",
		"manufacturedAt": "Port",
		"ingredientsWorth": 0,
		"totalProfit": -5748,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 5748,
		"index": 159
	},
	{
		"profit": 14982,
		"merchandisable": false,
		"raw": false,
		"date": 1955,
		"cost": 6200,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Silver Jewellery",
		"soldAt": "NOPE",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 0,
		"totalProfit": 14982,
		"composition": [
			"Silver"
		],
		"isWorthIt": true,
		"price": 26930,
		"totalCost": 11948,
		"index": 160
	},
	{
		"profit": 37730,
		"merchandisable": true,
		"raw": false,
		"date": 1970,
		"cost": 1920,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Skateboard",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 6500,
		"totalProfit": 37730,
		"composition": [
			"Wooden Board"
		],
		"isWorthIt": true,
		"price": 40690,
		"totalCost": 2960,
		"index": 161
	},
	{
		"profit": 26590,
		"merchandisable": true,
		"raw": false,
		"date": 1950,
		"cost": 1520,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Skis",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 6500,
		"totalProfit": 26590,
		"composition": [
			"Wooden Board"
		],
		"isWorthIt": true,
		"price": 29150,
		"totalCost": 2560,
		"index": 162
	},
	{
		"profit": 13690,
		"merchandisable": true,
		"raw": false,
		"date": 1922,
		"cost": 960,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Sledge",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 6500,
		"totalProfit": 13690,
		"composition": [
			"Wooden Board"
		],
		"isWorthIt": true,
		"price": 15690,
		"totalCost": 2000,
		"index": 163
	},
	{
		"profit": 15540,
		"merchandisable": true,
		"raw": false,
		"date": 1910,
		"cost": 1190,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Snow Shovel",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 3000,
		"totalProfit": 15540,
		"composition": [
			"Cut Wood",
			"Steel"
		],
		"isWorthIt": true,
		"price": 18300,
		"totalCost": 2760,
		"index": 164
	},
	{
		"profit": 44190,
		"merchandisable": true,
		"raw": false,
		"date": 1985,
		"cost": 1670,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Snowboard",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 9500,
		"totalProfit": 44190,
		"composition": [
			"Wooden Board",
			"Steel"
		],
		"isWorthIt": true,
		"price": 48150,
		"totalCost": 3960,
		"index": 165
	},
	{
		"profit": 38870,
		"merchandisable": true,
		"raw": false,
		"date": 1947,
		"cost": 800,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Sport Shoes",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 12240,
		"totalProfit": 38870,
		"composition": [
			"Fabrics",
			"Leather",
			"Rubber"
		],
		"isWorthIt": true,
		"price": 42150,
		"totalCost": 3280,
		"index": 166
	},
	{
		"profit": 1750,
		"merchandisable": false,
		"raw": false,
		"date": 1900,
		"cost": 850,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Steel",
		"soldAt": "NOPE",
		"manufacturedAt": "Forge",
		"ingredientsWorth": 0,
		"totalProfit": 1750,
		"composition": [
			"Iron Ore"
		],
		"isWorthIt": true,
		"price": 3000,
		"totalCost": 1250,
		"index": 167
	},
	{
		"profit": 11440,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 1230,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Summer Clothes",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 7920,
		"totalProfit": 11440,
		"composition": [
			"Fabrics"
		],
		"isWorthIt": true,
		"price": 13690,
		"totalCost": 2250,
		"index": 168
	},
	{
		"profit": 34530,
		"merchandisable": true,
		"raw": false,
		"date": 1955,
		"cost": 1780,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Sun Glasses",
		"soldAt": "NOPE",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 14160,
		"totalProfit": 34530,
		"composition": [
			"High Grade Steel",
			"Glass"
		],
		"isWorthIt": true,
		"price": 38470,
		"totalCost": 3940,
		"index": 169
	},
	{
		"profit": 18510,
		"merchandisable": true,
		"raw": false,
		"date": 1958,
		"cost": 720,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Sun Protection",
		"soldAt": "Home Appliances",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 0,
		"totalProfit": 18510,
		"composition": [
			"Petroleum"
		],
		"isWorthIt": true,
		"price": 19770,
		"totalCost": 1260,
		"index": 170
	},
	{
		"profit": 8372,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 360,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Tea",
		"soldAt": "Coffee Shop",
		"manufacturedAt": "Grocery",
		"ingredientsWorth": 0,
		"totalProfit": 8372,
		"composition": [
			"Tea Leaves"
		],
		"isWorthIt": true,
		"price": 16160,
		"totalCost": 7788,
		"index": 171
	},
	{
		"profit": -7428,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 7428,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Tea Leaves",
		"soldAt": "NOPE",
		"manufacturedAt": "Port",
		"ingredientsWorth": 0,
		"totalProfit": -7428,
		"composition": [],
		"isWorthIt": false,
		"price": 0,
		"totalCost": 7428,
		"index": 172
	},
	{
		"profit": 29970,
		"merchandisable": true,
		"raw": false,
		"date": 1932,
		"cost": 2030,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Telephone",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 2540,
		"totalProfit": 29970,
		"composition": [
			"Plastics",
			"Copper Wire"
		],
		"isWorthIt": true,
		"price": 34300,
		"totalCost": 4330,
		"index": 173
	},
	{
		"profit": 40300,
		"merchandisable": true,
		"raw": false,
		"date": 1959,
		"cost": 1290,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Tennis Racket",
		"soldAt": "Sports",
		"manufacturedAt": "Sports",
		"ingredientsWorth": 2770,
		"totalProfit": 40300,
		"composition": [
			"Aluminum",
			"Nylon"
		],
		"isWorthIt": true,
		"price": 43690,
		"totalCost": 3390,
		"index": 174
	},
	{
		"profit": 13001,
		"merchandisable": true,
		"raw": false,
		"date": 1914,
		"cost": -1,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Tissues",
		"soldAt": "Home Appliances",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 1770,
		"totalProfit": 13001,
		"composition": [
			"Grain Wood"
		],
		"isWorthIt": true,
		"price": 13840,
		"totalCost": 839,
		"index": 175
	},
	{
		"profit": 7360,
		"merchandisable": true,
		"raw": true,
		"date": 1900,
		"cost": 320,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Tomatoes",
		"soldAt": "Grocery",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": 7360,
		"composition": [],
		"isWorthIt": true,
		"price": 7680,
		"totalCost": 320,
		"index": 176
	},
	{
		"profit": 13270,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 1760,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Tools",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 9500,
		"totalProfit": 13270,
		"composition": [
			"Wooden Board",
			"Steel"
		],
		"isWorthIt": true,
		"price": 17320,
		"totalCost": 4050,
		"index": 177
	},
	{
		"profit": 4010,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 1120,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Tricycles",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 3000,
		"totalProfit": 4010,
		"composition": [
			"Steel"
		],
		"isWorthIt": true,
		"price": 6380,
		"totalCost": 2370,
		"index": 178
	},
	{
		"profit": 31070,
		"merchandisable": true,
		"raw": false,
		"date": 1929,
		"cost": 2460,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "TV Set",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 34430,
		"totalProfit": 31070,
		"composition": [
			"Wooden Board",
			"Electronic Components",
			"Glass"
		],
		"isWorthIt": false,
		"price": 38380,
		"totalCost": 7310,
		"index": 179
	},
	{
		"profit": 15700,
		"merchandisable": true,
		"raw": false,
		"date": 1935,
		"cost": 2390,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Tyres",
		"soldAt": "Car Dealer",
		"manufacturedAt": "Car Factory",
		"ingredientsWorth": 5390,
		"totalProfit": 15700,
		"composition": [
			"Steel",
			"Rubber"
		],
		"isWorthIt": true,
		"price": 20440,
		"totalCost": 4740,
		"index": 180
	},
	{
		"profit": -4210,
		"merchandisable": true,
		"raw": false,
		"date": 2011,
		"cost": -1,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Video Phone",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 20240,
		"totalProfit": -4210,
		"composition": [
			"Plastics",
			"Electronic Components"
		],
		"isWorthIt": false,
		"price": -1,
		"totalCost": 4209,
		"index": 181
	},
	{
		"profit": 49020,
		"merchandisable": true,
		"raw": false,
		"date": 1000,
		"cost": 2340,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Video Recorder",
		"soldAt": "Electronics",
		"manufacturedAt": "Electronics",
		"ingredientsWorth": 17700,
		"totalProfit": 49020,
		"composition": [
			"Aluminum",
			"Electronic Components"
		],
		"isWorthIt": true,
		"price": 55390,
		"totalCost": 6370,
		"index": 182
	},
	{
		"profit": 12020,
		"merchandisable": true,
		"raw": false,
		"date": 1921,
		"cost": 1390,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Wallpaper",
		"soldAt": "Book Shop",
		"manufacturedAt": "Book Shop",
		"ingredientsWorth": 6070,
		"totalProfit": 12020,
		"composition": [
			"Paper"
		],
		"isWorthIt": true,
		"price": 14610,
		"totalCost": 2590,
		"index": 183
	},
	{
		"profit": 37230,
		"merchandisable": true,
		"raw": false,
		"date": 1938,
		"cost": 3370,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Washing Machine",
		"soldAt": "Home Appliances",
		"manufacturedAt": "Home Appliances",
		"ingredientsWorth": 21390,
		"totalProfit": 37230,
		"composition": [
			"Steel",
			"Steel",
			"Electric Engines"
		],
		"isWorthIt": true,
		"price": 46610,
		"totalCost": 9380,
		"index": 184
	},
	{
		"profit": 44820,
		"merchandisable": true,
		"raw": false,
		"date": 1955,
		"cost": 1900,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Watch",
		"soldAt": "NOPE",
		"manufacturedAt": "NOPE",
		"ingredientsWorth": 16090,
		"totalProfit": 44820,
		"composition": [
			"High Grade Steel",
			"Leather",
			"Glass"
		],
		"isWorthIt": true,
		"price": 49240,
		"totalCost": 4420,
		"index": 185
	},
	{
		"profit": 17930,
		"merchandisable": true,
		"raw": false,
		"date": 1948,
		"cost": 890,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Watering Can",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 2540,
		"totalProfit": 17930,
		"composition": [
			"Plastics"
		],
		"isWorthIt": true,
		"price": 19840,
		"totalCost": 1910,
		"index": 186
	},
	{
		"profit": 150,
		"merchandisable": false,
		"raw": true,
		"date": 1900,
		"cost": 160,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Wheat",
		"soldAt": "NOPE",
		"manufacturedAt": "Farm",
		"ingredientsWorth": 0,
		"totalProfit": 150,
		"composition": [],
		"isWorthIt": true,
		"price": 310,
		"totalCost": 160,
		"index": 187
	},
	{
		"profit": 15590,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 1090,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Whisky",
		"soldAt": "Grocery",
		"manufacturedAt": "Brewery",
		"ingredientsWorth": 10540,
		"totalProfit": 15590,
		"composition": [
			"Glass",
			"Wheat"
		],
		"isWorthIt": true,
		"price": 17460,
		"totalCost": 1870,
		"index": 188
	},
	{
		"profit": 14020,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 1200,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Wine",
		"soldAt": "Grocery",
		"manufacturedAt": "Brewery",
		"ingredientsWorth": 17150,
		"totalProfit": 14020,
		"composition": [
			"Glass",
			"Grapes"
		],
		"isWorthIt": false,
		"price": 16840,
		"totalCost": 2820,
		"index": 189
	},
	{
		"profit": 12330,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 1570,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Winter Clothes",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 12140,
		"totalProfit": 12330,
		"composition": [
			"Wool",
			"Wool"
		],
		"isWorthIt": true,
		"price": 14460,
		"totalCost": 2130,
		"index": 190
	},
	{
		"profit": 28670,
		"merchandisable": true,
		"raw": false,
		"date": 1931,
		"cost": 1670,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Wood Instruments",
		"soldAt": "Instruments",
		"manufacturedAt": "Instruments",
		"ingredientsWorth": 10430,
		"totalProfit": 28670,
		"composition": [
			"Wooden Board",
			"High Grade Steel"
		],
		"isWorthIt": true,
		"price": 32920,
		"totalCost": 4250,
		"index": 191
	},
	{
		"profit": 5460,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 720,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Wooden Board",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 0,
		"totalProfit": 5460,
		"composition": [
			"Cut Wood"
		],
		"isWorthIt": true,
		"price": 6500,
		"totalCost": 1040,
		"index": 192
	},
	{
		"profit": 7790,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 2200,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Wooden Furniture",
		"soldAt": "Furniture",
		"manufacturedAt": "Furniture",
		"ingredientsWorth": 13000,
		"totalProfit": 7790,
		"composition": [
			"Wooden Board",
			"Wooden Board"
		],
		"isWorthIt": false,
		"price": 12070,
		"totalCost": 4280,
		"index": 193
	},
	{
		"profit": 6580,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 1920,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Wooden Ladder",
		"soldAt": "Home Hardware",
		"manufacturedAt": "Home Hardware",
		"ingredientsWorth": 6500,
		"totalProfit": 6580,
		"composition": [
			"Wooden Board"
		],
		"isWorthIt": true,
		"price": 9540,
		"totalCost": 2960,
		"index": 194
	},
	{
		"profit": 4080,
		"merchandisable": true,
		"raw": false,
		"date": 1900,
		"cost": 1280,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Wooden Loco",
		"soldAt": "Toys",
		"manufacturedAt": "Toys",
		"ingredientsWorth": 6500,
		"totalProfit": 4080,
		"composition": [
			"Wooden Board"
		],
		"isWorthIt": false,
		"price": 6400,
		"totalCost": 2320,
		"index": 195
	},
	{
		"profit": 5790,
		"merchandisable": true,
		"raw": true,
		"date": 1900,
		"cost": 280,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Wool",
		"soldAt": "Clothing",
		"manufacturedAt": "Sheep Farm",
		"ingredientsWorth": 0,
		"totalProfit": 5790,
		"composition": [],
		"isWorthIt": true,
		"price": 6070,
		"totalCost": 280,
		"index": 196
	},
	{
		"profit": 24810,
		"merchandisable": true,
		"raw": false,
		"date": 1907,
		"cost": 2190,
		"demand": 1,
		"priceAdjustment": 100,
		"name": "Working Clothes",
		"soldAt": "Clothing",
		"manufacturedAt": "Clothing",
		"ingredientsWorth": 9850,
		"totalProfit": 24810,
		"composition": [
			"Fabrics",
			"Leather"
		],
		"isWorthIt": true,
		"price": 28380,
		"totalCost": 3570,
		"index": 197
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/products.json
// module id = 161
// module chunks = 0